// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"8ed93c2b","537":"9b61fe3f","561":"8039b13e","686":"e465e701","721":"fe38db0c"}[chunkId] + ".chunk.js";
};